var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_47_2",
    "data-name": "Component 47 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.998,
    height: 16.769,
    viewBox: "0 0 16.998 16.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(-288.618 -128.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(288.618 128.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M305.616,139.126v6.367h-3.691v-5.94c0-1.492-.533-2.51-1.87-2.51a2.019,2.019,0,0,0-1.893,1.35,2.528,2.528,0,0,0-.122.9v6.2h-3.692s.049-10.06,0-11.1h3.692v1.573c-.008.012-.018.024-.024.037h.024v-.037a3.665,3.665,0,0,1,3.326-1.834c2.429,0,4.249,1.587,4.249,5Zm-17,6.367h3.69v-11.1h-3.69Zm0,0,3.8-14.869a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,292.418,130.624Z",
    transform: "translate(-288.618 -128.724)",
    fill: "#69efad"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.33a9c656b98d3bc3107bfc74cf7ca051.svg";
export { ForwardRef as ReactComponent };